import { useState } from 'react'
import { useDispatch } from 'react-redux'

export const getQueryParam = (param) => {
  const hash = window.location.search
  const queryString = hash.includes('?') ? hash.split('?')[1] : ''
  const params = new URLSearchParams(queryString)
  return params.get(param)
}

export const changeLangParam = (lang) => {
  const pathName = window.location.pathname
  const search = window.location.search
  const parts = pathName.split('/')
  parts[1] = lang
  const newPath = parts.join('/')
  window.history.replaceState({}, '', newPath + search)
}

export const isStageUrl = () => {
  try {
    let url = window.location.href
    const hostname = new URL(url).hostname
    return !hostname.includes('portal')
  } catch (e) {
    return false
  }
}

export const setSession = (
  applicantID,
  resData,
  expiryMinutes = 180,
  authToken = '',
) => {
  const expiryTime = new Date().getTime() + expiryMinutes * 60 * 1000
  localStorage?.setItem('expiry', expiryTime)
  localStorage?.setItem('isLogin', true)
  localStorage?.setItem('applicantID', applicantID)
  localStorage?.setItem('localProfileData', JSON.stringify(resData))

  if (authToken) {
    localStorage?.setItem('authToken', authToken)
  }
}

export const isSessionExpired = () => {
  const expiry = localStorage?.getItem('expiry')
  return expiry ? new Date().getTime() > Number(expiry) : false
}

export const clearSession = () => {
  const isRememberedLocal = localStorage?.getItem('isRemembered')
  const localEmail = localStorage?.getItem('email')
  const isRemembered = isRememberedLocal
  const email = localEmail

  if (isRememberedLocal === 'true' && localEmail && localEmail !== 'null') {
    localStorage.clear()
    localStorage?.setItem('isRemembered', isRemembered)
    localStorage?.setItem('email', email)
  } else {
    localStorage.clear()
  }
}

export function formatToLocalDate(iso) {
  const d = new Date(iso)
  const pad = (n) => String(n).padStart(2, '0')
  const yyyy = d.getFullYear()
  const mm = pad(d.getMonth() + 1)
  const dd = pad(d.getDate())
  const hh = pad(d.getHours())
  const min = pad(d.getMinutes())
  const ss = pad(d.getSeconds())
  return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`
}
